"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var identity_1 = require("@devsisters/ui-common/lib/identity");
var Popup_1 = require("../Popup");
var icons_1 = require("../icons");
var styles = require("./index.module.css");
var NavBar = /** @class */ (function (_super) {
    __extends(NavBar, _super);
    function NavBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { menuOpen: false };
        _this.openMenu = function () { return _this.setState({ menuOpen: true }); };
        _this.closeMenu = function () { return _this.setState({ menuOpen: false }); };
        return _this;
    }
    NavBar.prototype.renderLink = function (LinkComponent, _currentPath, to, text) {
        return (React.createElement(LinkComponent, { to: to },
            React.createElement("span", { className: styles.linkText }, text)));
    };
    NavBar.prototype.render = function () {
        var _a, _b, _c;
        var _this = this;
        var _d = this.props, className = _d.className, style = _d.style, mobileMenuStyle = _d.mobileMenuStyle, type = _d.type, links = _d.links, outerLinks = _d.outerLinks, _e = _d.currentPath, currentPath = _e === void 0 ? '/' : _e, _f = _d.LinkComponent, LinkComponent = _f === void 0 ? NavBar.defaultLinkComponent : _f, drawerOpen = _d.drawerOpen, drawerSize = _d.drawerSize, drawerChildren = _d.drawerChildren;
        var menuOpen = this.state.menuOpen;
        return (React.createElement("nav", { className: classnames_1.default(styles.navBar, (_a = {},
                _a[styles.pc] = type === 'pc',
                _a[styles.mobile] = type === 'mobile',
                _a), className), style: style },
            React.createElement("div", { className: styles.navContentWrapper },
                React.createElement("div", { className: styles.navContent },
                    type === 'mobile' && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.menuButton, onClick: this.openMenu },
                            React.createElement("svg", { viewBox: "0 0 28 25.5" },
                                React.createElement("path", { d: "M28,2.8H0V0h28V2.8z" }),
                                React.createElement("path", { d: "M28,14.2H0v-2.8h28V14.2z" }),
                                React.createElement("path", { d: "M28,22.7v2.8H0v-2.8" }))),
                        React.createElement(LinkComponent, { to: "/" },
                            React.createElement(LogoAndTitle, null)))),
                    type === 'pc' && (React.createElement(React.Fragment, null,
                        React.createElement(LinkComponent, { to: "/" },
                            React.createElement(LogoAndTitle, null)),
                        React.createElement("div", { className: styles.menu },
                            React.createElement("ul", { className: styles.links }, links.map(function (link, index) {
                                var _a;
                                return (React.createElement("li", { key: index, className: classnames_1.default((_a = {}, _a[styles.active] = currentPath === link.to, _a)) }, _this.renderLink(LinkComponent, currentPath, link.to, link.text)));
                            })),
                            React.createElement("ul", { className: styles.outerLinks }, outerLinks.map(function (link, index) { return (React.createElement("li", { key: index },
                                React.createElement("a", { href: link.to, target: "_blank" },
                                    React.createElement("span", { className: styles.linkText }, link.text)))); }))))))),
            type === 'mobile' && (React.createElement(Popup_1.default, { onClick: this.closeMenu, style: mobileMenuStyle, hide: !menuOpen },
                React.createElement("div", { className: classnames_1.default(styles.mobileMenu, (_b = {}, _b[styles.show] = menuOpen, _b)), onClick: function (e) { return e.stopPropagation(); } },
                    React.createElement("div", { className: styles.titleBar },
                        React.createElement(LogoAndTitle, null),
                        React.createElement("button", { className: styles.closeButton, onClick: this.closeMenu },
                            React.createElement(icons_1.CloseIcon, null))),
                    React.createElement("ul", null,
                        React.createElement("li", { className: classnames_1.default((_c = {}, _c[styles.active] = currentPath === '/', _c)), onClick: this.closeMenu }, this.renderLink(LinkComponent, currentPath, '/', '메인')),
                        links.map(function (link, index) {
                            var _a;
                            return (React.createElement("li", { key: index, className: classnames_1.default((_a = {}, _a[styles.active] = currentPath === link.to, _a)), onClick: _this.closeMenu }, _this.renderLink(LinkComponent, currentPath, link.to, link.text)));
                        })),
                    React.createElement("ul", null, outerLinks.map(function (link, index) { return (React.createElement("li", { key: index, onClick: _this.closeMenu },
                        React.createElement("a", { href: link.to, target: "_blank" },
                            React.createElement("span", { className: styles.linkText }, link.text)))); }))))),
            React.createElement("div", { className: styles.drawer, style: { flexBasis: (drawerOpen && drawerSize) || '0' } },
                React.createElement("div", { className: styles.drawerChildren, style: { height: drawerSize || '0' } }, drawerChildren))));
    };
    NavBar.defaultLinkComponent = (function (_a) {
        var children = _a.children;
        return children;
    });
    return NavBar;
}(React.Component));
exports.default = NavBar;
var LogoAndTitle = function () { return (React.createElement("div", { className: styles.logoAndTitle },
    React.createElement(identity_1.DevsistersCi, { className: styles.logo, style: { color: identity_1.devsistersCiColorBrightOrange } }),
    React.createElement("span", { className: styles.title }, "\uCC44\uC6A9"))); };
